import { useEffect, useRef } from 'react'

const useCreatePreview = ({
  backgroundColor,
  textColor,
  loadScriptContainerId,
  widgetContainerId,
  customTextTooBig,
  customTextTooSmall,
  sizingRecommendation,
  language,
}) => {
  const updateTimeOut = useRef()

  useEffect(() => {
    if (!backgroundColor || !textColor) return

    if (updateTimeOut.current) {
      clearTimeout(updateTimeOut.current)
    }

    updateTimeOut.current = setTimeout(() => {
      const script = document.createElement('script')
      script.defer = true
      const configurationObject = {
        text_color: textColor,
        background_color: backgroundColor,
        custom_texts: {
          too_big: customTextTooBig,
          too_small: customTextTooSmall,
        },
      }
      const sizeSuggestion = {
        ES: sizingRecommendation,
      }
      const params = new URLSearchParams()
      params.append('language', language)
      params.append('country', 'ES')
      params.append('containerId', widgetContainerId)
      params.append('sizeSuggestion', encodeURIComponent(JSON.stringify(sizeSuggestion)))
      params.append('configuration', encodeURIComponent(JSON.stringify(configurationObject)))

      script.src = `${import.meta.env.VITE_REVENI_SIZING_WIDGET}?${params.toString()}`

      const container = document.getElementById(loadScriptContainerId)
      container.innerHTML = ''

      document.getElementById(widgetContainerId)?.remove()

      const sizingWidgetContainer = document.createElement('div')
      sizingWidgetContainer.id = widgetContainerId
      container.parentNode.appendChild(sizingWidgetContainer)

      container.appendChild(script)

      return () => {
        container.innerHTML = ''
        document.getElementById(widgetContainerId)?.remove()
      }
    }, 500)
  }, [
    textColor,
    backgroundColor,
    loadScriptContainerId,
    widgetContainerId,
    customTextTooBig,
    customTextTooSmall,
    sizingRecommendation,
    language,
  ])
}

export default useCreatePreview
